module.exports = __webpack_public_path__ + "static/home-checklist-89b5c3cbff5884116fe8b1ad05da582a.png";